import { schema } from "normalizr";

export const activitySchema = new schema.Entity("activity", {});

export const activitiesSchema = new schema.Array(activitySchema);
